var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPentagonHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15.667a.833.833 0 01-.833.833H1.333a.833.833 0 01-.833-.833V6.908a.833.833 0 01.322-.658l6.666-5.185a.833.833 0 011.024 0l6.666 5.185a.832.832 0 01.322.658v8.759z",
    fill: "#5C5C8E"
  })));
}
export default __webpack_public_path__ + "static/svg/pentagon-house.svg";
export { SvgPentagonHouse as ReactComponent };